import { motion, AnimatePresence } from "framer-motion";
import { Button } from "../../components/ui/Button";

const backdropVariants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
};

const modalVariants = {
    hidden: { opacity: 0, scale: 0.9, y: -30 },
    visible: { opacity: 1, scale: 1, y: 0 },
};

export const ModalBase = ({
    title,
    modalState = {
        show: false,
        isEdit: false,
        identifier: "",
    },
    hiddenButton = false,
    children,
    buttonTitle = "",
    onClose = () => { },
    funcNewItem = () => { },
    funcEditItem = (identifier) => { },
}) => {
    const { show, isEdit, identifier } = modalState;
    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    className="fixed inset-0 p-2 z-50 flex items-center justify-center bg-black/50 bg-opacity-50"
                    initial="hidden"
                    animate="visible"
                    exit="hidden"
                    variants={backdropVariants}
                >
                    <motion.div
                        className="overflow-auto h-auto bg-white rounded-2xl shadow-xl max-w-md w-full p-6 relative"
                        initial="hidden"
                        animate="visible"
                        exit="hidden"
                        variants={modalVariants}
                        transition={{ duration: 0.3, ease: "easeOut" }}
                    >
                        <div className={`flex justify-${title ? 'between' : 'end'} items-center`}>
                            {title && <span className="text-gray-400">{title}</span>}
                            <Button className="px-1.5 py-0 flex items-center justify-center" variant="outline" onClick={onClose}>
                                &times;
                            </Button>
                        </div>

                        <div className="mt-4">{children}</div>

                        <div className="flex items-center justify-end mt-6">
                            {!hiddenButton && <Button variant="primary" onClick={() => isEdit ? funcEditItem(identifier) : funcNewItem()}>
                                {buttonTitle}
                            </Button>}
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
